import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import { api, bar, dateText, go, money, placeText, PRICE_LABEL, projectMeta, STATUS_TONE } from './util';
const person = u => u.avatarUrl ? m("img", {
  className: "Avatar",
  src: u.avatarUrl,
  alt: "",
  loading: "lazy"
}) : m("span", {
  className: "Avatar VBiz-avatar"
}, String(u.username || '?')[0].toUpperCase());
const num = v => Number(v || 0).toLocaleString('en-US', {
  maximumFractionDigits: 2
});

/**
 * /projects/{slug}: a project (community or personal). Its state and status, progress and money raised, then About, Timeline
 * (milestones its people tick off), What it needs (items, quantities and prices, how they're sourced, alternatives),
 * Money (pledged and received, recorded by its owners), People, Updates and Vouches. Owners edit everything here;
 * followers hear when it passes 50% and when it's completed.
 */
export default class ProjectView extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.slug = m.route.param('slug');
    this.p = null;
    this.error = null;
    this.posts = null;
    this.mine = null;
    this.editMs = null; // milestones being edited
    this.editItems = null; // items being edited
    this.fund = {
      kind: 'received',
      amount: '',
      fromName: '',
      itemId: '',
      note: ''
    };
    this.invite = {
      who: '',
      role: 'contributor'
    };
    this.followEmail = '';
    this.note = '';
    this.msg = null;
    this.load();
  }
  load() {
    app.request({
      method: 'GET',
      url: api('/projects/' + this.slug),
      errorHandler: () => {}
    }).then(r => this.got(r)).catch(e => this.error = e && e.response && e.response.message || 'This project could not be found.').then(() => m.redraw());
  }
  got(r) {
    if (r && r.project) {
      this.p = r.project;
      app.setTitle(this.p.name);
      if (this.posts === null) this.loadPosts();
    }
    if (r && r.message) this.msg = r.message;
  }
  loadPosts() {
    this.posts = undefined;
    app.store.find('discussions', {
      filter: {
        vouchaProject: String(this.p.id)
      },
      sort: '-createdAt',
      page: {
        limit: 10
      },
      include: 'user'
    }).then(list => this.posts = list || []).catch(() => this.posts = []).then(() => m.redraw());
  }
  act(method, path, body, done) {
    this.busy = path;
    this.msg = null;
    return app.request({
      method,
      url: api('/projects/' + this.p.id + path),
      body,
      errorHandler: () => {}
    }).then(r => {
      this.got(r);
      if (done) done(r);
    }).catch(e => this.msg = e && e.response && e.response.message || 'That didn’t work. Please try again.').then(() => {
      this.busy = null;
      m.redraw();
    });
  }
  logIn() {
    const b = document.querySelector('.item-logIn .Button, .item-logIn button');
    if (b) b.click();
  }
  copy() {
    const url = window.location.origin + '/projects/' + this.p.slug;
    const done = () => {
      this.copied = true;
      m.redraw();
      setTimeout(() => {
        this.copied = false;
        m.redraw();
      }, 2000);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, () => {});
  }
  view() {
    if (this.error) {
      return m("div", {
        className: "VEvt VEvt-empty"
      }, m("i", {
        className: "fas fa-people-carry-box",
        "aria-hidden": "true"
      }), m("h3", null, this.error), m(Button, {
        className: "Button",
        onclick: go('/projects')
      }, "All projects"));
    }
    const p = this.p;
    if (!p) return m(LoadingIndicator, null);
    const f = p.funding || {};
    const me = app.session.user;
    return m("article", {
      className: "VProj VProjD"
    }, m("div", {
      className: "VEvtD-bar"
    }, m("a", {
      href: "/projects",
      onclick: go('/projects')
    }, "\u2190 Projects"), m("span", null, m(Button, {
      className: "Button",
      icon: "far fa-copy",
      onclick: () => this.copy()
    }, this.copied ? 'Copied' : 'Copy link'), p.canEdit ? m(Button, {
      className: "Button",
      icon: "fas fa-pen",
      onclick: go('/projects/' + p.slug + '?edit=1')
    }, "Edit details") : null)), p.visibility === 'draft' ? m("p", {
      className: "VEvt-status is-pending"
    }, "Only its people can see this project until a second person joins. Then it\u2019s public.") : p.visibility === 'removed' ? m("p", {
      className: "VEvt-status is-rejected"
    }, "Taken down by a moderator", p.removedNote ? ': ' + p.removedNote : '', ".") : null, p.myStatus === 'invited' ? m("div", {
      className: "VProj-invited"
    }, m("span", null, "You\u2019ve been invited to this project as ", p.myRole === 'owner' ? 'a co-owner' : 'a contributor', "."), m(Button, {
      className: "Button Button--primary",
      loading: this.busy === '/accept',
      onclick: () => this.act('POST', '/accept')
    }, "Join"), m(Button, {
      className: "Button",
      onclick: () => this.act('DELETE', '/members/' + me.id(), null, () => m.route.set('/projects'))
    }, "Decline")) : null, m("header", {
      className: "VProjD-head"
    }, m("span", {
      className: "VProj-cardTop"
    }, m("span", {
      className: "VProj-status",
      style: {
        color: STATUS_TONE[p.status]
      }
    }, p.statusLabel), p.type === 'personal' ? m("span", {
      className: "VProj-badge"
    }, p.visibility === 'private' ? 'Private · personal' : 'Personal') : null, m("span", {
      className: "VProj-kind"
    }, p.kindLabel), p.industry ? m("span", {
      className: "VProj-kind"
    }, p.industry.name) : null), m("h1", null, p.name), m("p", {
      className: "VProj-place"
    }, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), " ", placeText(p), p.type !== 'personal' && p.state && p.state.tagSlug ? m("a", {
      href: '/t/' + p.state.tagSlug,
      onclick: go('/t/' + p.state.tagSlug)
    }, " \xB7 ", p.state.name, " community") : null), p.summary ? m("p", {
      className: "VProj-lead"
    }, p.summary) : null), this.tracker(p), this.statusBar(p), this.actions(p), this.msg ? m("p", {
      className: "VBiz-error"
    }, this.msg) : null, m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "About"), String(p.description || '').split('\n').filter(Boolean).map(t => m("p", null, t)), p.objectives && p.objectives.length ? m("div", null, m("h4", null, "Objectives"), m("ul", null, p.objectives.map(o => m("li", null, o)))) : null, p.outcomes && p.outcomes.length ? m("div", null, m("h4", null, "Expected outcomes"), m("ul", null, p.outcomes.map(o => m("li", null, o)))) : null), this.timeline(p), this.needs(p), p.kind !== 'monitoring' || (p.funds || []).length ? this.money(p) : null, this.people(p), m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Updates"), p.canUpdate ? m("div", {
      className: "VBizD-postTop"
    }, m("span", null, m("strong", null, "Post an update"), m("small", null, "Followers see it here and in the ", p.state ? p.state.name : 'state', " community.")), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-pen",
      onclick: () => this.compose()
    }, "New update")) : null, this.posts === undefined ? m(LoadingIndicator, null) : this.posts && this.posts.length ? m("ul", {
      className: "VProj-posts"
    }, this.posts.map(d => m("li", null, m("a", {
      href: app.route.discussion(d)
    }, d.title()), m("small", {
      className: "VBiz-muted"
    }, d.user() ? d.user().displayName() + ' · ' : '', humanTime(d.createdAt()))))) : m("p", {
      className: "VBiz-muted"
    }, "No updates yet.")), p.vouches && p.vouches.length ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Vouches (", p.vouchCount, ")"), m("div", {
      className: "VBizD-vouches"
    }, p.vouches.map(x => m("a", {
      href: app.route('user', {
        username: x.user.username
      })
    }, person(x.user), m("span", null, m("strong", null, x.user.displayName || x.user.username), x.note ? m("small", null, "\u201C", x.note, "\u201D") : null))))) : null, p.canModerate ? m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Moderation"), p.visibility === 'removed' ? m(Button, {
      className: "Button",
      onclick: () => this.act('POST', '/moderate', {
        remove: false
      })
    }, "Put it back") : m("div", {
      className: "VProj-inline"
    }, m("input", {
      className: "FormControl",
      placeholder: "Reason (shown to its people)",
      value: this.modNote || '',
      oninput: e => this.modNote = e.target.value
    }), m(Button, {
      className: "Button",
      onclick: () => this.act('POST', '/moderate', {
        remove: true,
        note: this.modNote || ''
      })
    }, "Take it down"))) : null, p.canEdit ? m("p", {
      className: "VProj-danger"
    }, m(Button, {
      className: "Button Button--link",
      onclick: () => {
        if (confirm('Delete ' + p.name + '? Its milestones, needs, money records and followers are removed. This can’t be undone.')) {
          this.act('DELETE', '', null, () => m.route.set('/projects'));
        }
      }
    }, "Delete this project")) : null, m("p", {
      className: "VEvt-note"
    }, "Projects are run by Voucha members. Voucha doesn\u2019t collect or hold money for them: amounts raised are recorded by each project\u2019s owners. A vouch is a member\u2019s personal endorsement."));
  }

  /** Follow, vouch, or (outside Voucha) follow by email */
  actions(p) {
    const me = app.session.user;
    if (p.visibility !== 'public') return null;
    if (!me) {
      return m("div", {
        className: "VProj-actionsBox"
      }, m("strong", null, "Follow this project"), m("p", {
        className: "VBiz-muted"
      }, "Get an email when it\u2019s halfway done and when it\u2019s completed. No account needed."), this.followSent ? m("p", null, this.followSent) : m("form", {
        className: "VProj-inline",
        onsubmit: e => {
          e.preventDefault();
          this.act('POST', '/follow-email', {
            email: this.followEmail
          }, r => this.followSent = r && r.message);
        }
      }, m("input", {
        className: "FormControl",
        type: "email",
        required: true,
        placeholder: "Your email",
        value: this.followEmail,
        oninput: e => this.followEmail = e.target.value
      }), m(Button, {
        className: "Button Button--primary",
        type: "submit",
        loading: this.busy === '/follow-email'
      }, "Follow")), m("p", {
        className: "VBiz-muted"
      }, "Or ", m("a", {
        onclick: () => this.logIn()
      }, "log in"), " to follow, vouch and get updates in the app."));
    }
    return m("div", {
      className: "VProj-actionsBox VProj-actionRow"
    }, p.myStatus !== 'active' ? m(Button, {
      className: 'Button' + (p.following ? '' : ' Button--primary'),
      icon: p.following ? 'fas fa-check' : 'fas fa-bell',
      loading: this.busy === '/follow',
      onclick: () => this.act(p.following ? 'DELETE' : 'POST', '/follow')
    }, p.following ? 'Following' : 'Follow') : null, p.canVouch && !p.vouched ? m("span", {
      className: "VProj-inline"
    }, m("input", {
      className: "FormControl",
      maxlength: "280",
      placeholder: "Why you vouch for it (optional)",
      value: this.note,
      oninput: e => this.note = e.target.value
    }), m(Button, {
      className: "Button",
      icon: "fas fa-thumbs-up",
      loading: this.busy === '/vouch',
      onclick: () => this.act('POST', '/vouch', {
        note: this.note
      })
    }, "Vouch \xB7 ", p.vouchCount)) : p.vouched ? m(Button, {
      className: "Button VBiz-vouched",
      icon: "fas fa-thumbs-up",
      onclick: () => this.act('DELETE', '/vouch')
    }, "You vouched \xB7 ", p.vouchCount) : m("span", {
      className: "VBiz-muted"
    }, p.vouchCount, " ", p.vouchCount === 1 ? 'vouch' : 'vouches', " \xB7 ", p.followerCount, " following"));
  }

  // ---------------------------------------------------------------- timeline

  timeline(p) {
    const ms = p.milestones || [];
    if (this.editMs) return this.timelineEditor(p);
    return m("section", {
      className: "VEvtD-about"
    }, m("div", {
      className: "VProj-sectionHead"
    }, m("h3", null, "Timeline"), p.canEdit ? m(Button, {
      className: "Button",
      icon: "fas fa-pen",
      onclick: () => this.editMs = ms.map(x => Object.assign({}, x))
    }, ms.length ? 'Edit milestones' : 'Add milestones') : null), ms.length ? m("ol", {
      className: "VProj-milestones"
    }, ms.map(x => m("li", {
      className: x.done ? 'is-done' : ''
    }, p.canUpdate ? m("input", {
      type: "checkbox",
      checked: x.done,
      "aria-label": 'Done: ' + x.title,
      onchange: e => this.act('POST', '/tick', {
        milestoneId: x.id,
        done: e.target.checked
      })
    }) : m("i", {
      className: x.done ? 'fas fa-circle-check' : 'far fa-circle',
      "aria-hidden": "true"
    }), m("div", null, m("strong", null, x.title), x.target ? m("span", null, m("b", null, "Target:"), " ", x.target) : null, x.indicator ? m("span", null, m("b", null, "Done when:"), " ", x.indicator) : null, m("small", {
      className: "VBiz-muted"
    }, [x.dueDate ? 'Due ' + dateText(x.dueDate) : null, x.done && x.doneAt ? 'Done ' + dateText(x.doneAt) : null, x.required > 0 ? 'Needs ' + money(x.required, p.currency) + (x.raised ? ' · ' + money(x.raised, p.currency) + ' raised' : '') : null].filter(Boolean).join(' · ')))))) : m("p", {
      className: "VBiz-muted"
    }, "No milestones yet."));
  }
  timelineEditor(p) {
    const list = this.editMs;
    const cell = (x, k, attrs = {}) => m("input", Object.assign({
      className: "FormControl",
      value: x[k] || '',
      oninput: e => x[k] = e.target.value
    }, attrs));
    return m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Edit milestones"), m("p", {
      className: "VBiz-muted"
    }, "Progress is the share of milestones done; a weight makes a bigger milestone count for more. Followers hear at 50% and when it\u2019s completed."), m("div", {
      className: "VProj-editList"
    }, list.map((x, i) => m("div", {
      className: "VProj-editRow"
    }, m("span", {
      className: "VProj-editNum"
    }, i + 1), m("div", {
      className: "VProj-grid"
    }, cell(x, 'title', {
      placeholder: 'Milestone',
      maxlength: 150
    }), cell(x, 'target', {
      placeholder: 'Target (e.g. 60 m deep, 3 classrooms)',
      maxlength: 300
    }), cell(x, 'indicator', {
      placeholder: 'Done when… (e.g. water test passed)',
      maxlength: 300
    }), m("span", {
      className: "VProj-inline"
    }, cell(x, 'dueDate', {
      type: 'date',
      'aria-label': 'Due date'
    }), cell(x, 'weight', {
      type: 'number',
      min: 1,
      max: 10,
      'aria-label': 'Weight',
      style: 'width:70px'
    }))), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-xmark",
      "aria-label": "Remove",
      onclick: () => list.splice(i, 1)
    })))), m("div", {
      className: "VProj-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-plus",
      onclick: () => list.push({
        title: '',
        weight: 1
      })
    }, "Add a milestone"), m(Button, {
      className: "Button Button--primary",
      loading: this.busy === '/milestones',
      onclick: () => this.act('POST', '/milestones', {
        milestones: list
      }, () => this.editMs = null)
    }, "Save"), m(Button, {
      className: "Button",
      onclick: () => this.editMs = null
    }, "Cancel")));
  }

  // ---------------------------------------------------------------- needs

  needs(p) {
    const items = p.items || [];
    if (this.editItems) return this.needsEditor(p);
    if (!items.length && !p.canEdit) return null;
    const meta = projectMeta() || {};
    const name = (list, k) => ((list || []).find(x => x.key === k) || {}).name || k;
    const groups = [{
      id: null,
      title: 'General'
    }].concat((p.milestones || []).map(x => ({
      id: x.id,
      title: x.title
    })));
    const row = i => m("tr", {
      className: i.optionGroup && !i.chosen ? 'is-alt' : ''
    }, m("td", null, m("strong", null, i.name), i.optionGroup ? m("small", {
      className: "VProj-option"
    }, i.chosen ? 'Chosen option' : 'Alternative', " \xB7 ", i.optionGroup) : null, i.note ? m("small", {
      className: "VBiz-muted"
    }, i.note) : null), m("td", null, name(meta.itemCategories, i.category)), m("td", null, num(i.quantity), i.unit ? ' ' + i.unit : ''), m("td", null, i.unitPrice !== null ? money(i.unitPrice, p.currency) : '—', m("small", {
      className: 'VProj-price is-' + i.priceStatus
    }, PRICE_LABEL[i.priceStatus] || 'My estimate'), i.reference && i.priceStatus !== 'reference' ? m("small", {
      className: "VBiz-muted"
    }, "Typical: ", money(i.reference.price, i.reference.currency)) : null, i.reference ? m("small", {
      className: "VBiz-muted",
      title: i.reference.source
    }, i.reference.place, " \xB7 ", dateText(i.reference.date)) : null), m("td", null, m("b", null, i.total ? money(i.total, p.currency) : '—')), m("td", null, i.actualCost !== null && i.actualCost !== undefined ? money(i.actualCost, p.currency) : '—'), m("td", null, i.sourcing ? name(meta.sourcing, i.sourcing) : '—', i.business ? m("small", null, m("a", {
      href: '/businesses/' + i.business.slug,
      onclick: go('/businesses/' + i.business.slug)
    }, i.business.name)) : null, p.nigeria && p.canUpdate ? m("small", null, m("a", {
      href: "#",
      onclick: e => {
        e.preventDefault();
        this.recommend(i);
      }
    }, this.rec && this.rec.item === i.id ? 'Hide businesses' : 'Find businesses')) : null), m("td", null, i.acquired ? m("span", {
      className: "VProj-got"
    }, "In hand") : i.raised ? money(i.raised, p.currency) + ' raised' : '—'));
    const recRow = i => this.rec && this.rec.item === i.id ? m("tr", {
      className: "VProj-recRow"
    }, m("td", {
      colspan: "8"
    }, this.recommendations(p, i))) : null;
    return m("section", {
      className: "VEvtD-about"
    }, m("div", {
      className: "VProj-sectionHead"
    }, m("h3", null, "What it needs"), p.canEdit ? m(Button, {
      className: "Button",
      icon: "fas fa-pen",
      onclick: () => this.editItems = items.map(x => Object.assign({}, x))
    }, items.length ? 'Edit needs' : 'Add what it needs') : null), items.length ? m("div", {
      className: "VProj-tableWrap"
    }, m("table", {
      className: "VProj-table"
    }, m("thead", null, m("tr", null, m("th", null, "Item"), m("th", null, "Type"), m("th", null, "Quantity"), m("th", null, "Unit price"), m("th", null, "Total"), m("th", null, "Spent"), m("th", null, "Sourcing"), m("th", null, "Status"))), groups.map(g => {
      const rows = items.filter(i => i.milestoneId === g.id);
      if (!rows.length) return null;
      return m("tbody", null, groups.length > 1 ? m("tr", {
        className: "VProj-group"
      }, m("td", {
        colspan: "8"
      }, g.id ? 'For: ' + g.title : 'Not tied to a milestone')) : null, rows.map(i => [row(i), recRow(i)]));
    }), m("tfoot", null, m("tr", null, m("td", {
      colspan: "4"
    }, "Estimated cost (chosen options)"), m("td", null, m("b", null, money((p.funding || {}).estimate, p.currency))), m("td", null, m("b", null, money((p.funding || {}).spent, p.currency))), m("td", {
      colspan: "2"
    }))))) : m("p", {
      className: "VBiz-muted"
    }, "Nothing listed yet."), p.nigeria && items.some(i => i.reference) ? m("p", {
      className: "VBiz-muted"
    }, "Reference prices are typical prices from the Voucha Data Hub for ", p.state ? p.state.name + ' State' : 'Nigeria', " (or national ones), with their source and date. They are a guide, not a quote: confirm prices with a supplier.") : null, !items.length && p.canEdit && (meta.templates || []).length ? m("div", {
      className: "VProj-tplRow"
    }, m("span", {
      className: "VBiz-muted"
    }, "Start from a template:"), meta.templates.map(t => m(Button, {
      className: "Button",
      onclick: () => this.act('POST', '/template', {
        template: t.key
      })
    }, t.name))) : null);
  }

  /** Businesses that could provide a requirement (Nigeria): loaded on demand under its row */
  recommend(i) {
    if (this.rec && this.rec.item === i.id) {
      this.rec = null;
      return;
    }
    this.rec = {
      item: i.id,
      list: null
    };
    app.request({
      method: 'GET',
      url: api('/projects/' + this.p.id + '/recommend?item=' + i.id),
      errorHandler: () => {}
    }).then(r => {
      if (this.rec && this.rec.item === i.id) this.rec = {
        item: i.id,
        list: r.businesses || [],
        note: r.note
      };
    }).catch(() => this.rec = {
      item: i.id,
      list: []
    }).then(() => m.redraw());
  }
  recommendations(p, i) {
    const r = this.rec;
    if (!r || r.list === null) return m(LoadingIndicator, {
      size: "small"
    });
    if (!r.list.length) {
      return m("p", {
        className: "VBiz-muted"
      }, r.note || 'No listed business provides this yet.', ' ', m("a", {
        href: "/businesses",
        onclick: go('/businesses')
      }, "Browse the directory"));
    }
    return m("div", {
      className: "VProj-recs"
    }, m("p", {
      className: "VBiz-muted"
    }, "Listed businesses that provide this, in ", p.state ? p.state.name : 'the state', " first. Vouches are members\u2019 endorsements; check them yourself."), r.list.map(b => m("div", {
      className: "VProj-rec"
    }, m("a", {
      className: "VProj-recName",
      href: '/businesses/' + b.slug,
      onclick: go('/businesses/' + b.slug)
    }, m("strong", null, b.name), b.verified ? m("i", {
      className: "fas fa-circle-check",
      title: "Verified",
      "aria-label": "Verified"
    }) : null), m("small", {
      className: "VBiz-muted"
    }, [b.category, b.place, b.inState ? null : 'outside the state'].filter(Boolean).join(' · ')), b.services.length ? m("small", null, b.services.join(', ')) : null, m("small", null, b.vouchCount, " ", b.vouchCount === 1 ? 'vouch' : 'vouches', b.projectsDone ? ' · ' + b.projectsDone + ' completed project' + (b.projectsDone === 1 ? '' : 's') : ''), m("span", {
      className: "VProj-recContact"
    }, b.contact.phone ? m("a", {
      href: 'tel:' + b.contact.phone
    }, b.contact.phone) : null, b.contact.email ? m("a", {
      href: 'mailto:' + b.contact.email
    }, "Email") : null, b.contact.url ? m("a", {
      href: b.contact.url,
      target: "_blank",
      rel: "noopener nofollow"
    }, "Website") : null, p.canEdit && (!i.business || i.business.id !== b.id) ? m("a", {
      href: "#",
      onclick: e => {
        e.preventDefault();
        this.useBusiness(i, b);
      }
    }, "Use for this") : null))));
  }

  /** The requirement's items as the save call wants them */
  itemsPayload(list) {
    return list.map(x => Object.assign({}, x, {
      businessId: x.businessId !== undefined ? x.businessId : x.business ? x.business.id : null
    }));
  }
  useBusiness(item, b) {
    const list = this.itemsPayload(this.p.items || []).map(x => x.id === item.id ? Object.assign(x, {
      businessId: b.id
    }) : x);
    this.act('POST', '/items', {
      items: list
    }, () => this.rec = null);
  }

  /** The tracker: what it costs, the budget, money secured and still needed, milestones and dates */
  tracker(p) {
    const t = p.tracker || {};
    const f = p.funding || {};
    const personal = p.type === 'personal';
    const box = (label, value, sub, extra) => m("div", {
      className: "VProj-meterBox"
    }, m("small", null, label), m("strong", null, value), extra || null, sub ? m("span", {
      className: "VBiz-muted"
    }, sub) : null);
    return m("div", {
      className: "VProjD-meters VProj-tracker"
    }, box('Progress', p.progress + '%', (t.milestonesDone || 0) + ' done · ' + (t.milestonesOpen || 0) + ' to go' + (t.milestonesOverdue ? ' · ' + t.milestonesOverdue + ' overdue' : ''), bar(p.progress, '#1b4540')), p.kind !== 'monitoring' ? box(personal ? 'Saved' : 'Raised', money(f.received, p.currency, true), (f.required > 0 ? 'of ' + money(f.required, p.currency, true) + ' · ' + money(f.remaining, p.currency, true) + ' to find' : 'No target yet') + (f.pledged > 0 ? ' · ' + money(f.pledged, p.currency, true) + ' pledged' : ''), bar(f.percent, '#b45309')) : null, p.kind !== 'monitoring' ? box('Budget used', t.budgetUsed !== null && t.budgetUsed !== undefined ? t.budgetUsed + '%' : '—', money(t.spent, p.currency, true) + ' spent of ' + money(t.budget, p.currency, true) + (t.estimate && t.estimate !== t.budget ? ' · estimate ' + money(t.estimate, p.currency, true) : ''), bar(t.budgetUsed, t.budgetUsed > 100 ? '#c0392b' : '#2563eb')) : null, box('Timeline', t.actualEnd ? 'Done ' + dateText(t.actualEnd) : t.expectedEnd ? 'Due ' + dateText(t.expectedEnd) : 'No end date', [t.startDate ? 'from ' + dateText(t.startDate) : null, t.durationDays ? Math.round(t.durationDays / 7) + ' weeks planned' : null, t.daysLate ? t.actualEnd ? t.daysLate + ' days late' : 'running ' + t.daysLate + ' days late' : null, t.nextMilestone && t.nextMilestone.dueDate ? 'next: ' + t.nextMilestone.title + ', ' + dateText(t.nextMilestone.dueDate) : null].filter(Boolean).join(' · ')));
  }

  /** Owners: mark it under way, paused, completed or cancelled; a nudge when it has been quiet for three months */
  statusBar(p) {
    if (!p.canEdit) return null;
    const meta = projectMeta() || {};
    const t = p.tracker || {};
    const quiet = t.lastUpdate && Date.now() - new Date(t.lastUpdate).getTime() > 90 * 864e5 && ['planning', 'active'].includes(p.status);
    return m("div", {
      className: 'VProj-statusBar' + (quiet ? ' is-quiet' : '')
    }, quiet ? m("strong", null, "No update in three months. Is it still going?") : m("span", {
      className: "VBiz-muted"
    }, "Status"), (meta.statuses || []).map(s => m(Button, {
      className: 'Button' + (p.status === s.key ? ' Button--primary' : ''),
      disabled: p.status === s.key,
      loading: this.busy === '/status' && this.wantStatus === s.key,
      onclick: () => {
        this.wantStatus = s.key;
        this.act('POST', '/status', {
          status: s.key
        });
      }
    }, s.name)));
  }
  needsEditor(p) {
    const meta = projectMeta() || {};
    const list = this.editItems;
    const ps = [{
      key: 'estimated',
      name: 'My estimate'
    }, {
      key: 'confirmed',
      name: 'Supplier quote'
    }];
    const inp = (x, k, attrs = {}) => m("input", Object.assign({
      className: "FormControl",
      value: x[k] === null || x[k] === undefined ? '' : x[k],
      oninput: e => x[k] = e.target.value
    }, attrs));
    const sel = (x, k, options, empty) => m("select", {
      className: "FormControl",
      value: x[k] || '',
      onchange: e => x[k] = e.target.value || null
    }, empty ? m("option", {
      value: ""
    }, empty) : null, options.map(o => m("option", {
      value: String(o.key)
    }, o.name)));
    const ms = (p.milestones || []).map(x => ({
      key: x.id,
      name: x.title
    }));
    return m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Edit what it needs"), m("p", {
      className: "VBiz-muted"
    }, "List each item with its quantity and price. For a choice (buy a pump, or have one made locally), give both the same option name and pick the one you\u2019ll go with: only that one counts towards the total."), m("div", {
      className: "VProj-editList"
    }, list.map((x, i) => m("div", {
      className: "VProj-editRow"
    }, m("span", {
      className: "VProj-editNum"
    }, i + 1), m("div", {
      className: "VProj-grid VProj-grid--items"
    }, inp(x, 'name', {
      placeholder: 'Item (e.g. solar panel 300W)',
      maxlength: 150
    }), sel(x, 'category', meta.itemCategories || []), m("span", {
      className: "VProj-inline"
    }, inp(x, 'quantity', {
      placeholder: 'Qty',
      inputmode: 'decimal',
      style: 'width:80px'
    }), inp(x, 'unit', {
      placeholder: 'Unit',
      maxlength: 30,
      style: 'width:90px'
    })), m("span", {
      className: "VProj-inline"
    }, inp(x, 'unitPrice', {
      placeholder: 'Unit price',
      inputmode: 'decimal',
      oninput: e => {
        x.unitPrice = e.target.value;
        if (x.priceStatus === 'reference') x.priceStatus = 'estimated';
      }
    }), sel(x, 'priceStatus', x.priceKey ? [{
      key: 'reference',
      name: 'Reference price'
    }].concat(ps) : ps)), x.reference ? m("span", {
      className: "VProj-inline VBiz-muted"
    }, "Typical ", money(x.reference.price, x.reference.currency), " per ", x.reference.unit, ", ", x.reference.place, ", ", dateText(x.reference.date), " (", x.reference.source, ")", x.priceStatus !== 'reference' || Number(x.unitPrice) !== x.reference.price ? m("a", {
      href: "#",
      onclick: e => {
        e.preventDefault();
        x.unitPrice = x.reference.price;
        x.priceStatus = 'reference';
      }
    }, " Use it") : null) : p.nigeria ? m("span", {
      className: "VProj-inline"
    }, this.priceSearch(p, x)) : null, inp(x, 'actualCost', {
      placeholder: 'Actually spent so far',
      inputmode: 'decimal'
    }), sel(x, 'sourcing', meta.sourcing || [], 'How it’s sourced…'), sel(x, 'milestoneId', ms, 'Not tied to a milestone'), m("span", {
      className: "VProj-inline"
    }, inp(x, 'optionGroup', {
      placeholder: 'Option name (for alternatives)',
      maxlength: 60
    }), x.optionGroup ? m("label", {
      className: "VProj-check"
    }, m("input", {
      type: "radio",
      name: 'opt-' + x.optionGroup,
      checked: !!x.chosen,
      onchange: () => list.forEach(y => y.optionGroup === x.optionGroup && (y.chosen = y === x))
    }), " Chosen") : null), m("span", {
      className: "VProj-inline"
    }, inp(x, 'note', {
      placeholder: 'Note (supplier, specification…)',
      maxlength: 300
    }), m("label", {
      className: "VProj-check"
    }, m("input", {
      type: "checkbox",
      checked: !!x.acquired,
      onchange: e => x.acquired = e.target.checked
    }), " In hand"))), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-xmark",
      "aria-label": "Remove",
      onclick: () => list.splice(i, 1)
    })))), m("div", {
      className: "VProj-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-plus",
      onclick: () => list.push({
        name: '',
        category: 'material',
        quantity: 1,
        priceStatus: 'estimated'
      })
    }, "Add an item"), m(Button, {
      className: "Button Button--primary",
      loading: this.busy === '/items',
      onclick: () => this.act('POST', '/items', {
        items: this.itemsPayload(list)
      }, () => this.editItems = null)
    }, "Save"), m(Button, {
      className: "Button",
      onclick: () => this.editItems = null
    }, "Cancel")));
  }

  /** Look up a reference price for an item (Nigeria): the Data Hub's prices for the state and national ones */
  priceSearch(p, x) {
    if (x.priceOpen === undefined) x.priceOpen = false;
    if (!x.priceOpen) {
      return m("a", {
        href: "#",
        className: "VBiz-muted",
        onclick: e => {
          e.preventDefault();
          x.priceOpen = true;
          x.priceQ = x.name;
          this.findPrices(p, x);
        }
      }, "Look up a reference price");
    }
    return m("span", {
      className: "VProj-priceFind"
    }, m("input", {
      className: "FormControl",
      placeholder: "e.g. cement",
      value: x.priceQ || '',
      oninput: e => x.priceQ = e.target.value,
      onkeydown: e => e.key === 'Enter' && (e.preventDefault(), this.findPrices(p, x))
    }), m(Button, {
      className: "Button",
      onclick: () => this.findPrices(p, x)
    }, "Find"), x.priceList === null ? m(LoadingIndicator, {
      size: "small"
    }) : (x.priceList || []).length ? m("ul", null, x.priceList.map(r => m("li", null, m("a", {
      href: "#",
      onclick: e => {
        e.preventDefault();
        Object.assign(x, {
          priceKey: r.key,
          unitPrice: r.price,
          priceStatus: 'reference',
          unit: x.unit || r.unit,
          reference: r,
          priceOpen: false
        });
      }
    }, r.name, ": ", money(r.price, r.currency), " per ", r.unit), m("small", {
      className: "VBiz-muted"
    }, " ", r.place, " \xB7 ", dateText(r.date), " \xB7 ", r.source)))) : x.priceList ? m("small", {
      className: "VBiz-muted"
    }, "No reference price found.") : null);
  }
  findPrices(p, x) {
    x.priceList = null;
    app.request({
      method: 'GET',
      url: api('/projects-prices?state=' + (p.stateId || '') + '&q=' + encodeURIComponent(x.priceQ || '')),
      errorHandler: () => {}
    }).then(r => x.priceList = r.prices || []).catch(() => x.priceList = []).then(() => m.redraw());
  }

  // ---------------------------------------------------------------- money

  money(p) {
    const funds = p.funds || [];
    const f = this.fund;
    return m("section", {
      className: "VEvtD-about"
    }, m("h3", null, p.type === 'personal' ? 'Money saved and received' : 'Money'), m("p", {
      className: "VBiz-muted"
    }, p.type === 'personal' ? 'What you’ve put aside or been given towards it. Voucha doesn’t hold money; this is your record.' : 'Recorded by the project’s owners. Voucha doesn’t collect or hold money: to give, contact the project’s people.'), funds.length ? m("ul", {
      className: "VProj-funds"
    }, funds.map(x => m("li", null, m("span", null, m("strong", null, x.fromName), m("small", {
      className: "VBiz-muted"
    }, [x.kind === 'pledge' ? 'Pledged' : 'Received', x.itemName ? 'for ' + x.itemName : null, x.note, x.at ? dateText(x.at) : null].filter(Boolean).join(' · '))), m("b", {
      className: x.kind === 'pledge' ? 'is-pledge' : ''
    }, money(x.amount, p.currency)), p.canEdit ? m(Button, {
      className: "Button Button--icon Button--link",
      icon: "fas fa-xmark",
      "aria-label": "Remove",
      onclick: () => this.act('DELETE', '/funds/' + x.id)
    }) : null))) : m("p", {
      className: "VBiz-muted"
    }, "Nothing recorded yet."), p.canEdit ? m("form", {
      className: "VProj-fundForm",
      onsubmit: e => {
        e.preventDefault();
        this.act('POST', '/funds', f, () => this.fund = {
          kind: 'received',
          amount: '',
          fromName: '',
          itemId: '',
          note: ''
        });
      }
    }, m("select", {
      className: "FormControl",
      value: f.kind,
      onchange: e => f.kind = e.target.value
    }, m("option", {
      value: "received"
    }, p.type === 'personal' ? 'Saved / received' : 'Received'), m("option", {
      value: "pledge"
    }, "Pledged")), m("input", {
      className: "FormControl",
      required: true,
      inputmode: "decimal",
      placeholder: 'Amount (' + p.currency + ')',
      value: f.amount,
      oninput: e => f.amount = e.target.value
    }), m("input", {
      className: "FormControl",
      maxlength: "120",
      placeholder: "From (name, or @username)",
      value: f.fromName,
      oninput: e => f.fromName = e.target.value
    }), m("select", {
      className: "FormControl",
      value: f.itemId,
      onchange: e => f.itemId = e.target.value
    }, m("option", {
      value: ""
    }, "For the project generally"), (p.items || []).map(i => m("option", {
      value: String(i.id)
    }, i.name))), m("input", {
      className: "FormControl",
      maxlength: "300",
      placeholder: "Note",
      value: f.note,
      oninput: e => f.note = e.target.value
    }), m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.busy === '/funds'
    }, "Record")) : null);
  }

  // ---------------------------------------------------------------- people

  people(p) {
    const list = p.people || [];
    const self = list.find(x => x.me && x.status === 'active');
    return m("section", {
      className: "VEvtD-about"
    }, m("h3", null, p.type === 'personal' ? 'People' : 'People'), p.type === 'personal' ? m("p", {
      className: "VBiz-muted"
    }, p.visibility === 'private' ? 'Only these people can see this project.' : 'Anyone can see this project; these people help run it.', " \u201CCan see it\u201D is look only; contributors can tick milestones and post updates.") : null, m("ul", {
      className: "VProj-people"
    }, list.map(x => m("li", null, m("a", {
      href: app.route('user', {
        username: x.username
      })
    }, person(x)), m("span", null, m("strong", null, x.displayName || x.username), m("small", {
      className: "VBiz-muted"
    }, [x.role === 'owner' ? 'Owner' : x.role === 'viewer' ? 'Can see it' : 'Contributor', x.status === 'invited' ? 'invited' : null, x.skills, x.contribution].filter(Boolean).join(' · '))), p.canEdit && !x.me ? m("span", {
      className: "VProj-inline"
    }, m("select", {
      className: "FormControl",
      value: x.role,
      onchange: e => this.act('POST', '/person', {
        userId: x.id,
        role: e.target.value
      }),
      "aria-label": "Role"
    }, m("option", {
      value: "owner"
    }, "Owner"), m("option", {
      value: "contributor"
    }, "Contributor"), p.type === 'personal' ? m("option", {
      value: "viewer"
    }, "Can see it") : null), m(Button, {
      className: "Button Button--icon Button--link",
      icon: "fas fa-xmark",
      "aria-label": "Remove",
      onclick: () => this.act('DELETE', '/members/' + x.id)
    })) : null)), (p.emailInvites || []).map(x => m("li", null, m("span", {
      className: "Avatar VBiz-avatar"
    }, "@"), m("span", null, m("strong", null, x.email), m("small", {
      className: "VBiz-muted"
    }, "Invited by email \xB7 ", x.role === 'owner' ? 'Owner' : x.role === 'viewer' ? 'Can see it' : 'Contributor')), m(Button, {
      className: "Button Button--icon Button--link",
      icon: "fas fa-xmark",
      "aria-label": "Cancel invitation",
      onclick: () => this.act('DELETE', '/email-invites/' + x.id)
    })))), self ? m("details", {
      className: "VProj-self"
    }, m("summary", null, "Your skills and part in it"), m("div", {
      className: "VProj-inline"
    }, m("input", {
      className: "FormControl",
      maxlength: "200",
      placeholder: "Skills (e.g. civil engineer, welder)",
      value: this.skills ?? self.skills ?? '',
      oninput: e => this.skills = e.target.value
    }), m("input", {
      className: "FormControl",
      maxlength: "300",
      placeholder: "What you\u2019re doing on it",
      value: this.part ?? self.contribution ?? '',
      oninput: e => this.part = e.target.value
    }), m(Button, {
      className: "Button",
      onclick: () => this.act('POST', '/person', {
        userId: app.session.user.id(),
        skills: this.skills ?? self.skills ?? '',
        contribution: this.part ?? self.contribution ?? ''
      })
    }, "Save"))) : null, p.myRole === 'owner' && p.myStatus === 'active' ? m("form", {
      className: "VProj-inline VProj-invite",
      onsubmit: e => {
        e.preventDefault();
        this.act('POST', '/invite', this.invite, () => this.invite = {
          who: '',
          role: 'contributor'
        });
      }
    }, m("input", {
      className: "FormControl",
      required: true,
      placeholder: p.type === 'personal' ? 'Share with: @username or email' : 'Invite: @username or email',
      value: this.invite.who,
      oninput: e => this.invite.who = e.target.value
    }), m("select", {
      className: "FormControl",
      value: this.invite.role,
      onchange: e => this.invite.role = e.target.value
    }, p.type === 'personal' ? m("option", {
      value: "viewer"
    }, "Can see it") : null, m("option", {
      value: "contributor"
    }, "Contributor"), m("option", {
      value: "owner"
    }, "Owner")), m(Button, {
      className: "Button",
      type: "submit",
      loading: this.busy === '/invite'
    }, p.type === 'personal' ? 'Share' : 'Invite')) : null, self ? m(Button, {
      className: "Button Button--link",
      onclick: () => {
        if (confirm('Leave ' + p.name + '?')) this.act('DELETE', '/members/' + app.session.user.id(), null, () => m.route.set('/projects'));
      }
    }, "Leave this project") : null);
  }

  /** A new discussion that becomes this project's update once posted (linkNewProjectDiscussion in util.js) */
  compose() {
    const p = this.p;
    app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
      user: app.session.user
    }).then(loaded => {
      if (!loaded) return;
      try {
        sessionStorage.setItem('vprojPending', JSON.stringify({
          id: p.id,
          slug: p.slug,
          name: p.name,
          at: Date.now()
        }));
      } catch (e) {}
      try {
        // the title starts with the project, and its state's community is ticked
        if (app.composer.fields && app.composer.fields.title && !app.composer.fields.title()) app.composer.fields.title('Projects - ' + p.name + ': ');
        const tag = p.type !== 'personal' && p.state && p.state.tagSlug ? app.store.getBy('tags', 'slug', p.state.tagSlug) : null;
        if (tag && app.composer.fields) app.composer.fields.tags = [tag];
      } catch (e) {}
      app.composer.show();
    });
  }
}
flarum.reg.add('voucha-community', 'forum/projects/ProjectView', ProjectView);